import { useMutation } from "react-query";
import axios from "axios";
import CustomToast from "../../atomic/customToast/CustomToast";

const usePost = () => {
  const localData = JSON.parse(localStorage.getItem("local_data"));
  const postMutation = useMutation(async ({ url, requestBody, cb }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/${url}`,
      requestBody,
      {
        headers: {
          // Authorization: `Bearer ${localData?.access_token}`,
          // "Content-Type": "application/json",
        },
      }
    );
    if (response?.status === 200 || response.status=== 201) {
      // alert(response?.status)
      cb(response.data);
    }
    return response.data;
  });

  const postData = async (url, requestBody, cb) => {
    try {
      await postMutation.mutateAsync({ url, requestBody, cb });
    } catch (error) {
      // Handle any error if needed
      CustomToast({ type: "error", message: `somethingg went wrong` });
      console.error("Error while posting data:", error);
    }
  };

  return { postData, ...postMutation };
};

export default usePost;
